import React from 'react';
export function DetailPageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-14851">
      <span className="sr-only" data-id="element-14852">Loading details…</span>
      {/* Back button and actions */}
      <div className="flex items-center justify-between" data-id="element-14853">
        <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-14854" />
        <div className="h-10 w-28 bg-gray-200 rounded-md" data-id="element-14855" />
      </div>
      {/* Main info card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-14856">
        <div className="flex items-start gap-4 mb-6" data-id="element-14857">
          <div className="w-16 h-16 bg-gray-200 rounded-full" data-id="element-14858" />
          <div className="flex-1" data-id="element-14859">
            <div className="h-8 w-64 bg-gray-200 rounded mb-3" data-id="element-14860" />
            <div className="space-y-2" data-id="element-14861">
              <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-14862" />
              <div className="h-4 w-40 bg-gray-200 rounded" data-id="element-14863" />
              <div className="h-4 w-56 bg-gray-200 rounded" data-id="element-14864" />
            </div>
          </div>
          <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-14865" />
        </div>
        {/* Stats */}
        <div className="pt-6 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-14866">
          {[1, 2, 3].map(i => <div key={i} data-id="element-14867">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2" data-id="element-14868" />
              <div className="h-8 w-32 bg-gray-200 rounded" data-id="element-14869" />
            </div>)}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-14870">
        <div className="border-b border-gray-200 flex gap-8 px-6" data-id="element-14871">
          {[1, 2, 3].map(i => <div key={i} className="py-4" data-id="element-14872">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14873" />
            </div>)}
        </div>
        {/* Tab content */}
        <div className="p-6 space-y-4" data-id="element-14874">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="border border-gray-200 rounded-lg p-4" data-id="element-14875">
              <div className="flex justify-between items-center" data-id="element-14876">
                <div className="flex-1 space-y-2" data-id="element-14877">
                  <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-14878" />
                  <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-14879" />
                </div>
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14880" />
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}